import React from 'react'
import { useDispatch } from 'react-redux'
import { folderActions } from 'src/state/redux/slice/folder'

import { DNABox, DNAModal, DNAText } from '@alucio/lux-ui'
import { DNAModalVariant } from 'src/components/DNA/Modal/DNAConnectedModal'
import { DocumentVersionORM, FolderItemORM, VERSION_UPDATE_STATUS } from 'src/types/types'
import { isCustomDeckORM, isDocumentVersionORM } from 'src/types/typeguards'
import { customDeckActions } from 'src/state/redux/slice/customDeck'

export const DNADocumentVersionUpdateModal: DNAModalVariant<{
  folderItemORM: FolderItemORM,
}> = (props) => {
  const { folderItemORM, toggleModal } = props
  let documentVersionORM: DocumentVersionORM | undefined

  if (isCustomDeckORM(folderItemORM.relations.item)) {
    const customDeckORM = folderItemORM.relations.item
    const updatedGroup = customDeckORM.meta.groupsORM.find(groupORM =>
      groupORM.meta.version.updateStatus === VERSION_UPDATE_STATUS.PENDING_MINOR,
    )
    if (updatedGroup) {
      documentVersionORM = updatedGroup.pages[0].documentVersionORM
    }
  }
  else if (isDocumentVersionORM(folderItemORM.relations.item)) {
    documentVersionORM = folderItemORM.relations.item
  }
  const dispatch = useDispatch()

  const onAction = () => {
    if (isCustomDeckORM(folderItemORM.relations.item)) {
      dispatch(customDeckActions.updateDocumentVersion([folderItemORM.relations.item]))
    }
    else {
      dispatch(folderActions.updateDocumentVersion([folderItemORM], false))
    }
    toggleModal()
  }

  return (
    <DNAModal>
      <DNAModal.Header>Update File</DNAModal.Header>
      <DNAModal.Body>
        <DNABox appearance="col" spacing="medium">
          <DNAText bold>
            {documentVersionORM?.model.title}
          </DNAText>
          <DNABox style={{ maxWidth: 560 }} appearance="col" spacing="small">
            <DNAText>RELEASE NOTES</DNAText>
            <DNAText>
              {/* eslint-disable-next-line max-len */}
              {documentVersionORM?.relations.document.relations.version.latestDocumentVersionPublished?.model.releaseNotes}
            </DNAText>
          </DNABox>
        </DNABox>
      </DNAModal.Body>
      <DNAModal.Confirmation
        onCancel={toggleModal}
        onAction={onAction}
        actionLabel="Update"
        actionStatus="success"
      />
    </DNAModal>
  )
}

export default DNADocumentVersionUpdateModal
